import { FC, HTMLAttributes } from 'react';
import { useIntroduction } from '../../services/graph/hooks/introduction';
import { PageSizer } from '../page/PageSizer';
import { BackgroundImage } from './BackgroundImage';
import { FadeColor, FadeTrapezium } from './FadeTrapezium';

export const LargeBackground: FC<HTMLAttributes<HTMLDivElement>> = ({ className }) => {
  const introduction = useIntroduction();

  if (!introduction.data) {
    throw Error('Could not get image data');
  }

  const backgroundImages = introduction.data.backgroundImages.homePage;

  return (
    <div className={className}>
      <div className="bg-primary-50 h-full w-[50%] top-0 left-0 absolute" />
      <div className="bg-primary-800 h-full w-[50%] top-0 right-0 absolute" />
      <PageSizer className="h-full z-[2] relative">
        <div className="w-[125%] md:w-3/4 md:translate-x-[50%] relative h-full overflow-hidden">
          <FadeTrapezium className="w-1/6 h-full absolute top-0 left-[-1px] z-[100]" fadeColor={FadeColor.LIGHT} />
          <FadeTrapezium
            reverse
            slant={5}
            className="hidden md:block w-5/6 h-full absolute top-0 right-[-4px] z-[100]"
            fadeColor={FadeColor.DARK}
          />
          <FadeTrapezium
            reverse
            slant={5}
            className="md:hidden w-[200%] h-full absolute top-0 left-0 z-[100]"
            fadeColor={FadeColor.DARK}
          />
          {backgroundImages.map((img, index) => (
            <BackgroundImage
              src={img}
              className="absolute h-full w-[99%] left-1"
              animationIndex={backgroundImages.length > 1 ? index : undefined}
              animationCount={backgroundImages.length}
              key={img}
            />
          ))}
        </div>
      </PageSizer>
    </div>
  );
};
